import {css} from "@emotion/react";
import React, {useEffect, useState} from 'react';
import {Button, message, Space, Tabs} from 'antd';
import PrismHighlighter from "@/components/PrismHighlighter/PrismHighlighter";
import {CopyrightOutlined} from "@ant-design/icons";
import CopyToClipboard from "react-copy-to-clipboard";

const cssViewer = css({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    // padding: 4,
})

const cssTabs = css({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flexGrow: 1,
    '& .ant-tabs-nav::before': {
        border: 'none!important'
    },
    '& .ant-tabs-nav': {
        marginBottom: 0,
        '& .ant-tabs-nav-list': {
            '& .ant-tabs-tab': {
                backgroundColor: 'rgb(34, 32, 36)',
                // borderColor: 'rgb(255,255,255,0.65)',
                color: 'rgb(255,255,255,0.65)',
                // borderTop: '1px solid #f0f0f0',
                borderImage: 'linear-gradient(to right, #8f41e9, #0099CC, #8f41e9) 1',
                borderBottom: 'none',

            },
            '& .ant-tabs-tab.ant-tabs-tab-active': {
                backgroundColor: 'rgb(40, 38, 43)',
                // color: 'rgb(255, 255, 255)!important',
            },
            '& .ant-tabs-tab-remove': {
                color: 'rgb(255, 255, 255)',
            },
            '& .ant-tabs-tab-btn': {
                // color: 'rgb(255, 255, 255)!important',
            }
        }
    },
    '& .ant-tabs-content-holder': {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flexGrow: 1,
        '& .ant-tabs-content': {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            flexGrow: 1,
            borderTop: '1px solid #f0f0f0',
            borderImage: 'linear-gradient(to right, #8f41e9, #0099CC, #8f41e9) 1',
            '& .ant-tabs-tabpane': {
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                flexGrow: 1,
                paddingLeft: 4,
                paddingRight: 4,

                '&>.content': {
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'auto',
                    flexGrow: 1,
                    color: 'white',
                    '&>.content-toolbar': {
                        display: 'flex',
                        // justifyContent: 'flex-end',
                        alignItems: 'center',
                        padding: '8px 8px 0 8px',
                        flexShrink: 0,
                    }
                }
            },
            '& .ant-tabs-tabpane-hidden': {
                display: 'none',
            },
        }
    }
})

const Viewer = ({newOpenItem, ...props}) => {
    const [activeKey, setActiveKey] = useState();
    const [openedItems, setOpenedItems] = useState([])

    const onChange = (newActiveKey) => {
        setActiveKey(newActiveKey);
    };

    const onEdit = (targetKey, action) => {
        if (action !== 'add') {
            for (let i = 0; i < openedItems.length; i++) {
                if (openedItems[i].key == targetKey) {
                    if (openedItems[i - 1]) {
                        setActiveKey(openedItems[i - 1].key)
                    } else if (openedItems[i + 1]) {
                        setActiveKey(openedItems[i + 1].key)
                    } else {
                        setActiveKey(null)
                    }
                }
            }
            setOpenedItems(openedItems.filter(({key}) => key != targetKey))
        }
    }

    useEffect(() => {
        if (newOpenItem) {
            console.log('newOpenItem', newOpenItem)
            if (newOpenItem.type === 'file') {
                if (openedItems.find(openedItem => openedItem.key === newOpenItem.key)) {
                    //切换激活面板
                    console.log('切换激活面板', newOpenItem)
                    setActiveKey(newOpenItem.key);
                } else {
                    console.log('打开新面板', newOpenItem)
                    //打开新面板
                    setOpenedItems([...openedItems, newOpenItem]);
                    setActiveKey(newOpenItem.key);
                }
            }
        }
    }, [newOpenItem])

    return (
        <div css={cssViewer}>
            <Tabs
                size='small'
                hideAdd
                css={cssTabs}
                type="editable-card"
                onChange={onChange}
                activeKey={activeKey}
                onEdit={onEdit}
                items={openedItems.map(({key, name, fileContent}) => {
                    return {
                        label: name,
                        children: (
                            <div className='content'>
                                <div className='content-toolbar'>
                                    <CopyToClipboard text={fileContent} onCopy={() => message.success({title: '提示', content: '复制成功'})}>
                                        <a>
                                            <Space>
                                                <CopyrightOutlined/>
                                                复制
                                            </Space>
                                        </a>
                                    </CopyToClipboard>
                                </div>
                                <PrismHighlighter name={name} content={fileContent}/>
                                {/*<pre>*/}
                                {/*    {fileContent}*/}
                                {/*</pre>*/}
                            </div>
                        ),
                        key: key,
                    }
                })}
            />
        </div>
    )
}

export default Viewer;
